import {apolloClient} from "seu-frontend/graphql/apollo";
import GET_POST from "./getPost.gql";
import LIST_POSTS from "./listPosts.gql";
import LIST_RELATED_POSTS from "./listRelatedPosts.gql";

const getPost = ({id, lang, slug}) => {
  return apolloClient.query({
    query: GET_POST,
    variables: {
      id,
      lang,
      slug
    },
    fetchPolicy: 'no-cache'
  }).then(({data: {post}}) => post)
};

const listPosts = ({pagination, search, filter} = {}) => {
  return apolloClient.query({
    query: LIST_POSTS,
    variables: {
      input: {
        pagination,
        search,
        filter
      },
    },
    fetchPolicy: 'no-cache'
  }).then(({data: {posts}}) => posts)
};

const listRelatedPosts = ({pagination, id, lang} = {}) => {
  return apolloClient.query({
    query: LIST_RELATED_POSTS,
    variables: {
      input: {
        pagination,
        id,
        lang
      },
      lang: lang
    },
    fetchPolicy: 'no-cache'
  }).then(({data: {posts}}) => posts)
};


export {
  getPost,
  listPosts,
  listRelatedPosts
}
